import React from 'react';

interface StatusColorsBlockProps {
  status: string;
  description: string;
}

const StatusColorsBlock: React.FC<StatusColorsBlockProps> = ({ status, description }) => {
  return (
    <div className="d-flex gap-2 align-items-center">
      <div style={{ width: 24, height: 24, backgroundColor: status }} />
      <span className="ml-2 text-muted fs-12">{description}</span>
    </div>
  );
};

export default StatusColorsBlock;
